import Button from 'components/Button';
import InputUseForm from "components/InputUseForm";
import { capitalize, toLower } from 'lodash';
import { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { Select } from 'antd';
import { storeAsociacion, deleteAsociacion, getAsociacion, getAsociaciones } from 'services/Asociaciones';
import dayjs from "dayjs";

export default function FormAssociations({ specialties, isLoading, editData }) {
    const { register, handleSubmit, reset, setValue, formState: { errors }, control } = useForm()
    const [isEditing, setIsEditing] = useState(false)
    const [isEditingSubmit, setIsEditingSubmit] = useState(false)
    const [dataEditId, setDataEditId] = useState(null)

    const onSubmit = async (data) => {

        data.fecha_desde = dayjs(data.fecha_desde).format('YYYY-MM-DD')
        data.fecha_hasta = dayjs(data.fecha_hasta).format('YYYY-MM-DD')

        if (isEditingSubmit) {
            storeAsociacion(data, dataEditId).then((response) => {
                if (response) {
                    window.location.reload();
                } else {
                    console.error(response)
                }
            })
        } else {
            storeAsociacion(data).then((response) => {
                if (response) {
                    window.location.reload();
                } else {
                    console.error(response)
                }
            })
        }

    }

    const handleCancel = () => {
        reset()
        setValue('asociacion', null)
        setIsEditing(false)
    }


    useEffect(() => {
        // console.log(editData)
        if (editData) {
            setIsEditing(true)
            setDataEditId(editData[0].id)
            setValue('nombre', editData[0].nombre)
            setValue('nombre_contacto', editData[0].nombre_contacto)
            setValue('email', editData[0].email)
            setValue('telefono', editData[0].telefono)
            setValue('fecha_desde', dayjs(editData[0].fecha_desde))
            setValue('fecha_hasta', dayjs(editData[0].fecha_hasta))
            setValue('observaciones', editData[0].observaciones)
        }
    }, [editData])


    return (
        <div className="w-full flex min-h-40 h-fit rounded-b-md items-start flex-col pb-10">
            <form onSubmit={handleSubmit(onSubmit)} className="w-full bg-white rounded-b-md p-8 transition-all">
                <InputUseForm
                    label="Nombre"
                    name="nombre"
                    register={register}
                    errors={errors}
                    placeholder="Ingrese el nombre de la asociación"
                    rules={{ required: "El nombre es requerido" }}
                    className="w-full"
                />

                <InputUseForm
                    label="Nombre contacto"
                    name="nombre_contacto"
                    register={register}
                    errors={errors}
                    placeholder="Ingrese el nombre del contacto"
                    rules={{ required: "El nombre es requerido" }}
                    className="w-full"
                />

                <InputUseForm
                    label="Email"
                    name="email"
                    register={register}
                    errors={errors}
                    placeholder="Ingrese el email de la asociación"
                    className="w-full"
                />

                <InputUseForm
                    label="Teléfono"
                    name="telefono"
                    register={register}
                    errors={errors}
                    placeholder="Ingrese el teléfono de la asociación"
                    className="w-full"
                />

                <InputUseForm
                    label="Observacion"
                    name="observaciones"
                    register={register}
                    errors={errors}
                    placeholder="Ingrese alguna observación"
                    className="w-full"
                />

                <div className="w-full flex justify-between gap-4">
                    <InputUseForm
                        label="Fecha desde"
                        name="fecha_desde"
                        register={register}
                        errors={errors}
                        placeholder="DD/MM/AAAA"
                        rules={{ required: "La fecha es requerida" }}
                        className="w-full"
                        type="date"
                        format="DD/MM/YYYY"
                        control={control}
                    />

                    <InputUseForm
                        label="Fecha hasta"
                        name="fecha_hasta"
                        register={register}
                        errors={errors}
                        placeholder="DD/MM/AAAA"
                        rules={{ required: "La fecha es requerida" }}
                        className="w-full"
                        type="date"
                        format="DD/MM/YYYY"
                        control={control}
                    />
                </div>

                {isEditing ?
                    <div className="w-full flex justify-start gap-4">
                        <Button isLoading={isLoading} type="submit" label="Actualizar asociación" className="mt-8" onClick={() => setIsEditingSubmit(true)} />
                        <Button isLoading={isLoading} label="Cancelar" className="mt-8 bg-red-500 text-white" onClick={handleCancel} />
                    </div>
                    :
                    <Button isLoading={isLoading} type="submit" label="Crear asociación" className="mt-8" onClick={() => setIsEditingSubmit(false)} />
                }
            </form>
        </div>
    );
}
